<template>
<div class="concact">
    <public-head :backgroundImage="bg" subTitle="CONTACT US" title="联系我们" :show="false" />
    <div class="wrap">
        <div>
            <p class="title">联系我们</p>
            <p class="sub-title">CONTACT US</p>
            <div>
                <div>
                    <img src="../assets/img/Shape.png" alt srcset />
                    <span>电话</span>
                    <img src="../assets/img/hr.png" class="hr" srcset />
                    <span>{{detail.tel}}</span>
                </div>
                <div>
                    <img src="../assets/img/Mail.png" alt srcset />
                    <span>邮箱</span>
                    <img src="../assets/img/hr.png" class="hr" srcset />
                    <span>{{detail.yx}}</span>
                </div>
                <div>
                    <img src="../assets/img/Print.png" alt srcset />
                    <span>传真</span>
                    <img src="../assets/img/hr.png" class="hr" srcset />
                    <span>{{detail.cz}}</span>
                </div>
                <div>
                    <img src="../assets/img/Location.png" alt srcset />
                    <span>地址</span>
                    <img src="../assets/img/hr.png" class="hr" srcset />
                    <span>{{'成都市郫都区成都现代工业港南片区新经济产业园文明街西段288号'}}</span>
                </div>
            </div>
        </div>
    </div>
    <baidu-map :center="center" :zoom="15" id="map" class="baidu-map-view" ak="YhllasINn7Y0zyEGLyXmBGx47AVBwAxM" :marker="center" scroll-wheel-zoom>
        <bm-marker key="marker.code" :position="center">
            <bm-info-window :position="center" :show="true">
                <div class="wrapper">
                    <img src="../assets/img/logo2.png" alt srcset />
                </div>
            </bm-info-window>
        </bm-marker>
    </baidu-map>
</div>
</template>

<script>
import {
    BaiduMap,
    BmScale,
    BmGeolocation,
    BmNavigation,
    BmMarkerClusterer,
    BmMarker,
    BmInfoWindow,
    BmTransit,
    BmOverlay,
} from "vue-baidu-map";
import {
    pz
} from "../assets/js/api";
export default {
    components: {
        BaiduMap,
        BmMarker,
        BmMarkerClusterer,
        BmScale,
        BmNavigation,
        BmInfoWindow,
        BmTransit,
        BmOverlay,
    },
    data() {
        return {
            center: {
                lng: 109.45744048529967,
                lat: 36.49771311230842,
            },
            detail: {},
            bg: require('../assets/img/contact_banner.png')
        };
    },
    created() {
        pz().then((r) => {
            this.detail = r.data;
            this.center.lng = r.data.x;
            this.center.lat = r.data.y;
        });
    },
    methods: {
        draw({
            el,
            BMap,
            map
        }) {
            const pixel = map.pointToOverlayPixel(new BMap.Point(this.center));
            el.style.position = "absolute";
            el.style.left = pixel.x - 6 + "px";
            el.style.top = pixel.y + "px";
        },
    },
};
</script>

<style lang="less" scoped>
.concact {
    padding-bottom: 90px;
}

.title {
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #000000;
    text-align: center;
}

.sub-title {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #cccccc;
    text-align: center;
    line-height: 20px;
    margin-bottom: 60px;
}

.wrap {
    padding: 90px 0;

    &>div {
        width: 1200px;
        margin: 0 auto;

        &>div {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            &>div {
                display: flex;
                flex-direction: column;
                align-items: center;
                max-width: 177px;
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;

                color: rgba(56, 56, 56, 1);

                img {
                    width: 119px;
                    height: 119px;
                    margin-bottom: 30px;
                }

                .hr {
                    width: 100%;
                    height: 10px;
                    margin-top: 17px;
                    margin-bottom: 19px;
                }
            }
        }
    }
}

#map {
    width: 100%;
    height: 740px;
}

.wrapper {
    width: 290px;
    height: 108px;
    background: url("../assets/img/overlay.png") no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 167px;
        height: 60px;
        object-fit: cover;
    }
}
</style>
